module.exports = __webpack_public_path__ + "static/futureface-daeea4d231b261a46592a00db6d418d2.jpg";